import { FacultySettingsForm } from "../Forms";

export const FacultySettingsPage = () => {
	return <FacultySettingsForm />;
};
